/**
 * Main JS file for project.
 */

// Define globals that are added through the config.json file, here like this:
/* global Ractive */
'use strict';
import $ from 'jquery';
import 'selectric';
import tap from 'ractive-events-tap/dist/ractive-events-tap.es.js';

Ractive.events.tap = tap;
Ractive.DEBUG = /unminified/.test(function(){/*unminified*/});

import { loadCandidates } from './candidates.js';
import utilsFn from './utils.js';

const stances = [
  'education',
  'environment',
  'jobs',
  'pensions',
  'plannedParenthood',
  'taxes',
  'transit'
];
let initialLoad = true;

function titleize(string) {
  string = string.replace(/([A-Z])/, ' $1');
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function renderReset() {
  util.pym.scrollParentToChildPos(-100);
  window.scroll(0, 0);
}

// Setup utils function
const util = utilsFn({ });
const landingPage = new Ractive({
  template: '#landingPage',
  el: '#content',
  data: {
    stances,
    titleize
  },
  showStance: function(stance) {
    stancePage.set('stance', stance);
    this.unrender();
    stancePage.render('#content');
  },
  onrender() {
    if (initialLoad) {
      initialLoad = false;
    } else {
      renderReset();
    }
  }
});

const stancePage = new Ractive({
  template: '#stances',
  data: {
    stances,
    titleize,
    getStance(candidate, stance) {
      return candidate[stance];
    },
  },
  onrender() {
    renderReset();
    let stance = this.get('stance');
    let stances = this.get('stances');
    $('#stances-dropdown').selectric();
    $('#stances-dropdown').prop('selectedIndex', stances.indexOf(stance)).selectric('refresh');
    $('#stances-dropdown').selectric().on('change', e => this.set('stance', e.target.value));
  },
  goToLanding() {
    $('#stances-dropdown').selectric('destroy');
    this.unrender();
    landingPage.render('#content');
  },
  goToCandidate(candidate) {
    candidateDetail.set('candidate', candidate);
    $('#stances-dropdown').selectric('destroy');
    this.unrender();
    candidateDetail.render('#content');
  }
});

const candidateDetail = new Ractive({
  template: '#candidate-detail',
  
  onrender: renderReset,
  goToStances() {
    this.unrender();
    stancePage.render('#content');
  }
});

new Ractive({
  el: '#calendar-icon',
  template: '#calendar-svg'
});

new Ractive({
  el: '#location-icon',
  template: '#location-svg'
});

new Ractive({
  el: '#facebook-icon',
  template: '#facebook-svg'
});

new Ractive({
  el: '#twitter-icon',
  template: '#twitter-svg'
});

new Ractive({
  el: '#wnyc-logo',
  template: '#wnyc-svg'
});

new Ractive({
  el: '#njspotlight-logo',
  template: '#njspotlight-svg'
});

loadCandidates().then(c => stancePage.set('candidates', c));



// WEBPACK FOOTER //
// ./app/index.js